import { Button, FormGroup, Toolbar } from "@mui/material";
import React, { ReactNode, useState } from "react";
import { PageContentFooterPortal } from "../../../../common/layout/PageContent";
import { ProgressFooter, ProgressFooterActions } from "../../get-compliant/ProgressFooter";

type EditTabProps = {
  isEditing: boolean;
  editLabel?: ReactNode;
  saveLabel?: ReactNode;
  saveDisabled?: boolean;
  editDisabled?: boolean;
  saveDisabledLabel?: string;
  onEnableEditing: () => void;
  onDisableEditing: () => void;
  children?: ReactNode;
};
export const EditTab = ({
  children,
  isEditing,
  editLabel = "Edit",
  saveLabel = "Done",
  saveDisabled = false,
  editDisabled = false,
  saveDisabledLabel = "",
  onEnableEditing,
  onDisableEditing,
}: EditTabProps) => {
  const [saving, setSaving] = useState(false);

  const handleDisableEdit = async () => {
    setSaving(true);
    await onDisableEditing();
    setSaving(false);
  };

  return (
    <>
      {children}

      {!isEditing && (
        <Toolbar disableGutters>
          <FormGroup className="mt-xl">
            <Button
              onClick={onEnableEditing}
              disabled={editDisabled}
              variant="contained"
              color="primary"
            >
              {editLabel}
            </Button>
          </FormGroup>
        </Toolbar>
      )}

      <PageContentFooterPortal visible={isEditing}>
        <ProgressFooter
          actions={
            <ProgressFooterActions
              nextLoading={saving}
              nextContent={saveLabel}
              nextOnClick={handleDisableEdit}
              nextDisabled={saveDisabled}
              nextDisabledTooltip={saveDisabledLabel}
            />
          }
        />
      </PageContentFooterPortal>
    </>
  );
};
